import React from "react";
import { SecondaryButton } from "../../../Common/Buttons/SecondaryButton";
import text from "../../../../locale.en.json";

const RelevancyButton = ({ getRelevancyButtonProps, type }) => {
  const { handleClick, isContentSelected } = getRelevancyButtonProps(type);

  return (
    <SecondaryButton
      onClick={handleClick}
      className="more_action"
      disabled={!isContentSelected}
    >
      {text.content.markAs.replace("{{relevancy}}", type)}
    </SecondaryButton>
  );
};

export default RelevancyButton;
